module.exports = __webpack_public_path__ + "img/td_ad_09.16df5239.jpg";